module.exports = __webpack_public_path__ + "static/eye-of-vecna-mtg_afr-3dcfd2819724a53e0ccd0e7bb4c77f1d.jpg";